import React from "react";
import ReactDOM from "react-dom";

import CrashDialog, { CrashDialogProps } from "./components/CrashDialog";

let alreadyCrashed = false;

export function showCrashDialog(props: CrashDialogProps): void {
  if (alreadyCrashed) {
    console.warn("Ignoring another crash");
    return;
  }

  alreadyCrashed = true;

  console.error("Showing CrashDialog:");
  console.error(props.error);
  const root = document.createElement("div");
  document.body.appendChild(root);
  ReactDOM.render(<CrashDialog {...props} />, root);
}
